import { useMemo } from 'react';
import * as yup from 'yup';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';

export const useFormDocUpload = (params = {}) => {
	const { values, sign } = params;

	const initialValues = useMemo(() => {
		return {
			title: '',
			files: [],
			signed: '0',
			...values,
		};
	}, [values]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							field: {
								type: FORM_LINE_TYPES.upload,
								connected: true,
								params: {
									name: 'files',
									label: 'Загрузка файла',
								},
							},
						},
						{
							id: 2,
							field: {
								type: FORM_LINE_TYPES.textfield,
								connected: true,
								params: {
									name: 'title',
									label: 'Название',
									placeholder: 'Например: Договор на подписание',
								},
							},
						},
						sign
							? {
								id: 3,
								field: {
									type: FORM_LINE_TYPES.radio,
									connected: true,
									params: {
										label: 'Договор подписан?',
										name: 'signed',
										options: [
											{ label: 'Да', value: '1' },
											{ label: 'Нет', value: '0' },
										],
										group: {
											row: true,
										},
									},
								},
							}
							: null,
					].filter((i) => !!i),
				},
			],
		};
	}, [sign]);

	const validationSchema = yup.object().shape({
		title: yup.string().required('Укажите название'),
		files: yup
			.array()
			.min(1, 'Загрузите файл')
			.required('Загрузите файл'),
	});

	return { shape, initialValues, validationSchema };
};
